import { Box, Typography } from '@mui/material';
import '../modal/modal.css';
import * as FaIcons from 'react-icons/fa';
import { QRCodeCanvas } from 'qrcode.react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { callPostApi } from '../../function/ApiCallFunction';
import { compressImage } from '../../function/ImageFunction';
import ImagePreview from '../CommanComponents/ImagePreview';

export default function ViewQrcodeCustPaymentInfo({  dataArr, onClose }) 
{  
    const { history_id,store_id,cust_upi_id, cust_name, cust_mobile, amount, qrcode_number, redeem_date,payment_flag,pay_trans_id,pay_trans_image} = dataArr;           
    
    const qrIdPrint = `upi://pay?pa=${cust_upi_id}&pn=${cust_name}&am=${amount}&cu=INR`;

    const [payTransId,      setPayTransId]    = useState(pay_trans_id);
    const [payTransImage,   setPayTransImage] = useState('');

    const [payTransIdEBox,      setPayTransIdBox]       = useState('');
    const [payTransImageEBox,   setPayTransImageEBox]   = useState('');

    // Handle file change and compression
    const handleFileChange = async (e) => 
    {
        const { files } = e.target;
        if (!files || files.length === 0) return;

        const file = files[0];
        if (!validateImage(file)) return;

        try 
        {
            const compressedImage = await compressImage(file);
            setPayTransImage(compressedImage);
        } 
        catch (err) {
            console.error("Image compression failed:", err);
            setPayTransImageEBox('Image compression failed.');
        }
    };

    // Validate image file
    const validateImage = (file) => 
    {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const maxSize = 5 * 1024 * 1024; // 5MB max

        if (!allowedTypes.includes(file.type)) { setPayTransImageEBox('Only JPEG, PNG, and JPG formats are allowed.'); return false; }
        if (file.size > maxSize) { setPayTransImageEBox('Image size should be less than 5MB.');  return false; }

        setPayTransImageEBox('');
        return true;
    };

    const handleSave = async () => 
    {   
        let errorFlag = true;

        if (!payTransId)   { setPayTransIdBox('Please enter Transaction Id.');  errorFlag = false; }
            
        if (errorFlag) 
        {
            const data_arr = { store_id, history_id, 'pay_trans_id':payTransId, 'pay_trans_image':payTransImage}
            const payload = { mod: "QRCODE_CUST_PAYMENT_REFUND", data_arr };

            console.log("payload = ",JSON.stringify(payload));

            try 
            {
                const response = await callPostApi('cashi-qrcode', payload);
                if (response.status === '200') 
                {
                    toast.success(`Payment Updated successfully.`, { position: 'top-right' });
                    onClose();
                } 
                else {  toast.error(response.status_message);  }
            } 
            catch (error) { toast.error("Failed to save changes", { position: 'top-right' }); }            
        }
    };

    return (
        <div className="modal-overlay" >
        <div className="modal-container" style={{ maxWidth: '50%'}}>
                        
           <div className='headerStyles' ><h6>{cust_name} : {qrcode_number}  </h6> <span className='closeButtonStyles' onClick={onClose} >X</span></div>
           
            <div className="modal-content">
                <div className="row">
    
                    {/* Left Side */}
                    <div className="col-12 col-md-8">
                        <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>UPI Id:</b> {cust_upi_id}</Typography>
                        <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Customer Mobile:</b> {cust_mobile}</Typography>
                        <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Amount:</b> {amount}</Typography>
                        <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}><b>Redeem Date:</b> {redeem_date}</Typography>
                    </div>
                    <div className="col-12 col-md-4 d-flex justify-content-center align-items-center">
                        <QRCodeCanvas value={qrIdPrint} size={100} />
                    </div>

                </div>

                <div className='row col-12 mb-2 mt-4'>
                    <div className='col-12 col-md-3'><label> Transaction Id <span style={{color:'red',fontSize:'10px'}}> <FaIcons.FaAsterisk /> </span></label></div>
                    <div className='col-12 col-md-9'>
                        <input type="text" className="form-control" value={payTransId} onChange={(e) => setPayTransId(e.target.value)} placeholder="Transaction Id" 
                        readOnly={Number(payment_flag) === 1} />
                        <span className="col-12 mb-3" style={{color:'red'}} >{payTransIdEBox}</span>
                    </div>
                </div>

                {Number(payment_flag) === 0 && (
                    <>                
                    <div className='row col-12 mb-2 mt-4'>
                        <div className='col-12 col-md-3'><label> Image Upload </label></div>
                        <div className='col-12 col-md-9'>
                            <input type="file" name="payTransImage" className="form-control" accept="image/*" onChange={handleFileChange} />
                            <span className="col-12 mb-3" style={{color:'red'}} >{payTransImageEBox}</span>
                        </div>
                    </div>
                    </>
                )}
                
                {pay_trans_image && ( <><Box mt={2}><ImagePreview src={pay_trans_image} /></Box> </>)}

            </div>
   
           <div className="modal-actions" style={{justifyContent: 'flex-end' }}>
              <button onClick={onClose} className="btn-group btn-confirm m-1">Close</button>
              {Number(payment_flag) === 0 && ( <button onClick={handleSave} className="btn-group btn-confirm m-1">Save</button> )}     
           </div>

       </div>
       </div>
    );
}
